@import '../../content/Variables.scss';

.datepicker-wrap {
    > div {
        display: block;
        width: 100%;
        z-index: 11;
    }

    .react-datepicker {
        font-family: 'Gotham Narrow';
    }

    .react-datepicker__input-container {
        display: block;
    }

    .react-datepicker-wrapper {
        display: block;

        input {
            width: 100%;

            &:hover {
                cursor: pointer;
            }

            &:focus {
                box-shadow: none;
                outline: none;
            }
        }
    }

    .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
        border-bottom-color: $white;
    }

    .react-datepicker__header{
        background-color: $white;
        border-bottom: none;
        font-family: 'Gotham Bold';

        .react-datepicker__current-month{
            text-transform: uppercase;
            padding: .6rem 0 .2rem 0;
        }
    }

    .react-datepicker__day-name, 
    .react-datepicker__day, 
    .react-datepicker__time-name {
        color: $black;
        display: inline-block;
        width: 3rem;
        line-height: 3rem;
        text-align: center;
        margin: 0;
        font-size: 1.3rem;
    }

    .react-datepicker__day-name {
        text-transform: uppercase;
        font-size: 1rem;
        font-weight: bold;
    }

    .react-datepicker__day--selected, 
    .react-datepicker__day--in-selecting-range, 
    .react-datepicker__day--in-range {
        border-radius: 0.3rem;
        background-color: $standard-blue;
        color: $white;
    }

    .react-datepicker__day--disabled {
        color: $grey;
    }

    .react-datepicker__navigation--previous,
    .react-datepicker__navigation--next{
        border: none;
        height: 30px;
        width: 30px;
        background-size: contain;
        background-repeat: no-repeat;
        top: .5rem;
    }

    .react-datepicker__navigation--previous {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAyUlEQVR4Ae3cAQYCQRTH4XeARHdYYA3mzVVCVwjoAtH5gqD7VIG6wHpqv4+5wO8PrJ0JAAAAAAAAAACAX5KZlzHGOcqI/3ifzDwFNfGNUB//+xyDkvj1I4j/Ob33fVAT/3XurbVdIL74iC8+i8a/FcYXf5qmbSC++IgvPsvFz8yr+IXx53neBOKLj/jiI74BMIIRMIIRMIKPcfgcbQSMYASMYAT8Hef/UIxgBIyw9kt6h/gvrqnioranCvBYh+dqAAAAAAAAAAAAniqSI39+t10zAAAAAElFTkSuQmCC);
    }

    .react-datepicker__navigation--next {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAA1UlEQVR4Ae3cAQbCYBzG4Q6QiI4wYIbtPU1HCAgQSOcLgtBtamHQAb5/43noAu8Pmu37NgAAAAAAAAAAAC0luU7TdNuUMP4lyfv7E6GxefDzMr4IheOL0FiS0zK2CI2N43hcRhahQJJDkqcIhYZh2IsgAiKIgAgi8BPhURiBrut2IoiACCIgggj8WQQR5mHvhRHo+35bEAERBMD4xl8V4/v7iQcw42N842N8L+XxWYrxMb7xMb5TMsZ/GX+Nh/RwTNVBbVxV4LIOXFcDAAAAAAAAAADwAephJFWvaMW3AAAAAElFTkSuQmCC);
    }

    .react-datepicker__today-button{
        text-transform: uppercase;
        background-color: $white;
        font-family: 'Gotham';
        border-top: none;
        color: $standard-blue;
        font-size: 1.2rem;
        padding: .5rem 0 1rem 1rem;
    }

    &.render-inline {
        display: inline-block;

        .react-datepicker-wrapper {
            display:inline-block;

            input {
                background: transparent;
                border: none;
                padding-left: 1rem;
                color: $bright-blue;
                text-decoration: underline;
            }
        }
    }

    .include-up-to {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        label {
            display: flex;
            flex-direction: row;
            justify-content: center;
            padding: .4rem;

            input {
                margin-left: .8rem;
            }

        }

        button {
            background-color: $bright-blue;
            color: $white;
            width: 100%;
            border: none;
            font-size: 1.3rem;
            padding: 1rem;            
        }

        p {
            margin-bottom: 0;
            font-size: 1.2rem;
            text-transform: uppercase;
        }
    }

    .datepicker-checkbox-label {
        position: absolute;
        top: 1rem;
        right: .5rem;
        font-size: 1rem;
        text-align: right;
        width: auto;
        background: $near-white;
        border-radius: 2rem;
        padding: .5rem 1rem;
    }

}
